/**
 * LAY CHUONG TRINH FONT NHUNG SAN TU pdf.js.
 *
 * CANH BAO VE DO TIN CAY, phai doc truoc khi dung ket qua cua module nay:
 *
 *   Byte ma pdf.js dat vao commonObjs KHONG PHAI byte nguyen ban trong file PDF.
 *   pdf.js phan tich font roi DUNG LAI mot sfnt hop le de trinh duyet nap duoc.
 *   Trong qua trinh do no co the vut bo hoac ghi de bang OS/2 - tuc la fsType
 *   doc duoc tu day co the la 0 (tu do cai dat) trong khi font THAT cam nhung.
 *
 *   Vi vay bytesAreOriginal LUON la false o day, va resolve.ts se danh dau
 *   fsTypeTrusted=false. Ban Rust/PDFium doc thang /FontFile2 va /FontFile3 nen
 *   se cho cau tra loi dung ve mat phap ly; ban web chi co the than trong.
 */
import type { TextBlock } from '@pdfeditor/types';
import type { PdfJsFontObject, PdfJsObjectStore } from '../fontDiagnostics';
import type { EmbeddedFontSource } from './resolve';

function toBytes(data: PdfJsFontObject['data']): Uint8Array | null {
  if (!data) return null;
  if (data instanceof Uint8Array) return data;
  if (data instanceof ArrayBuffer) return new Uint8Array(data);
  return null;
}

/**
 * Dung ban ghi font nguon cho mot khoi van ban.
 *
 * Lay font cua RUN DAU TIEN. Mot khoi tron nhieu font (chu dam giua cau, mot tu
 * bang font khac) se bi go lai bang MOT font duy nhat - day la mot xap xi, va no
 * duoc bao ra ngoai qua canh bao "da thay font" khi tang phan giai tra ve
 * substituted=true. Ban Rust/PDFium giu duoc nhieu run va nhieu font trong mot
 * khoi; ban web thi khong.
 */
export function embeddedFontSourceForBlock(
  commonObjs: PdfJsObjectStore,
  block: TextBlock,
): EmbeddedFontSource | null {
  const first = block.runs.find((r) => r.text.length > 0);
  if (!first) return null;

  let font: PdfJsFontObject | null = null;
  try {
    if (commonObjs.has(first.fontRef)) {
      font = commonObjs.get(first.fontRef) as PdfJsFontObject;
    }
  } catch {
    // commonObjs.get nem loi khi doi tuong chua duoc giai quyet.
    font = null;
  }

  const declared = block.fonts[0]?.baseFont ?? first.fontRef;
  const bytes = toBytes(font?.data ?? null);

  return {
    baseFont: font?.name ?? declared,
    // missingFile = PDF khong nhung font. Khong co byte thi khong co tang A.
    bytes: font?.missingFile === true ? null : bytes,
    isType3: font?.isType3Font === true,
    // Luon false: xem khoi canh bao dau file.
    bytesAreOriginal: false,
  };
}
